<template>
  <el-select
    v-model="value"
    multiple
    placeholder="All"
    @update:modelValue="update"
  >
    <el-option
      v-for="item in browserOptions"
      :key="item.key"
      :label="item.label"
      :value="item.key"
    />
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { Browser, BrowserLabel, BrowserLabels } from '@/api/types'

type BrowserEntry = {
  key: Browser
  label: string
  disabled: boolean
}

export default defineComponent({
  name: 'BrowserSelect',
  props: {
    modelValue: {
      type: Array,
      required: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const browserOptions = BrowserLabels.map<BrowserEntry>(
      (browserLabel: BrowserLabel) => {
        return {
          key: browserLabel.type_id,
          label: browserLabel.label,
          disabled: false
        }
      }
    )

    const update = (newValue: Array<Browser>) => {
      context.emit('update:modelValue', newValue)
    }

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )

    return { update, browserOptions, value }
  }
})
</script>
